var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1367 9.66675C15.5201 9.66675 16.6284 8.55008 16.6284 7.16675C16.6284 5.78341 15.5201 4.66675 14.1367 4.66675C12.7534 4.66675 11.6367 5.78341 11.6367 7.16675C11.6367 8.55008 12.7534 9.66675 14.1367 9.66675ZM7.47005 9.66675C8.85339 9.66675 9.96172 8.55008 9.96172 7.16675C9.96172 5.78341 8.85339 4.66675 7.47005 4.66675C6.08672 4.66675 4.97005 5.78341 4.97005 7.16675C4.97005 8.55008 6.08672 9.66675 7.47005 9.66675ZM7.47005 11.3334C5.52839 11.3334 1.63672 12.3084 1.63672 14.2501V16.3334H13.3034V14.2501C13.3034 12.3084 9.41172 11.3334 7.47005 11.3334ZM14.1367 11.3334C13.8951 11.3334 13.6201 11.3501 13.3284 11.3751C14.2951 12.0751 14.9701 13.0167 14.9701 14.2501V16.3334H19.9701V14.2501C19.9701 12.3084 16.0784 11.3334 14.1367 11.3334Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.a96c970edd24eccbc5aac4df6f5d4aab.svg";
export { ForwardRef as ReactComponent };